<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" v-bind="$attrs">
        New project
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title">
        Create project
      </v-card-title>

      <v-card-text>
        <v-divider class="pb-6"></v-divider>

        <project-create-edit-form ref="createEditForm" v-if="dialog">
          <template #buttons-after>
            <v-btn depressed color="error" class="ml-2" @click="dialog = false"
              >Cancel</v-btn
            >
          </template>
        </project-create-edit-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProjectCreateEditForm from './ProjectCreateEditForm'

export default {
  name: 'ProjectCreateModal',
  components: {
    ProjectCreateEditForm
  },
  data: () => ({
    dialog: false
  })
}
</script>
